import ViewModelCore from "./ViewModel";

export default class InstrucoesCarregamentoViewModel extends ViewModelCore{
    constructor () {
        super();
		this.PedidoId = undefined;
		this.PedidoInstrucoesCarregamentoId = undefined;
		this.PedidoParcelaId = undefined;
		this.UsuarioId = undefined;
		this.NumeroLiberacaoCarregamento = undefined;
		this.NumeroParcela = undefined;
		this.DataCarregamentoFormatada = undefined;
		this.DataLiberacaoCarregamentoFormatada = undefined;
		this.QuantidadeCarregada = undefined;
		this.QuantidadeLiberada = undefined;
		this.NumeroOrdemDeCompra = undefined;
		this.NumeroMinimo = undefined;
		this.NumeroMaximo = undefined;
		this.CodigoExterno = undefined;
		this.DescricaoObservacao = undefined;
		this.NomeUsuario = undefined;
		this.QuantidadePedidoParcela = undefined;
		this.LiberadoParaProduzir = undefined;
		this.QuantidadeProduzida = undefined;
		this.QuantidadeExpandida = undefined;
		this.NumeroQuantidadeTotalFormatado = undefined;
		this.NomeProduto = undefined;
		this.DescricaoFaseProduto = undefined;
		this.ComponenteTipoEnumTexto = undefined;
		this.DataEntregaFormatada = undefined;
		this.TipoPedidoTexto = undefined;
		this.DataBasePedidoParcelaFormatada = undefined;



    }
}
